var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.0791L3 0.0791016L0 2.0791V17.0791C0 17.8748 0.316071 18.6378 0.87868 19.2004C1.44129 19.763 2.20435 20.0791 3 20.0791H17C17.7956 20.0791 18.5587 19.763 19.1213 19.2004C19.6839 18.6378 20 17.8748 20 17.0791V14.0791H18V2.0791L15 0.0791016L12 2.0791L9 0.0791016L6 2.0791ZM16 14.0791H4V17.0791C4 17.3443 3.89464 17.5987 3.70711 17.7862C3.51957 17.9737 3.26522 18.0791 3 18.0791C2.73478 18.0791 2.48043 17.9737 2.29289 17.7862C2.10536 17.5987 2 17.3443 2 17.0791V3.1491L3 2.4831L6 4.4831L9 2.4831L12 4.4831L15 2.4831L16 3.1491V14.0791ZM17 18.0791H5.83C5.94 17.7661 6 17.4291 6 17.0791V16.0791H18V17.0791C18 17.3443 17.8946 17.5987 17.7071 17.7862C17.5196 17.9737 17.2652 18.0791 17 18.0791Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.d8f2a43c9c0ae2458b526737e89d9490.svg";
export { ForwardRef as ReactComponent };